/**
 * Meeting Management — query keys, options, and default colour maps.
 * Mirrors ProjectManagement/utils/projectConstants.ts.
 */

export const MEETING_QUERY_KEYS = {
  all: ['meetings'] as const,
  listView: ['meetings', 'list-view'] as const,
  view: (id: number) => ['meetings', 'view', id] as const,
  forProject: (projectId: number) => ['meetings', 'project', projectId] as const,
  attendees: (id: number) => ['meeting', id, 'attendees'] as const,
  comments: (id: number) => ['meeting', id, 'comments'] as const,
  files: (id: number) => ['meeting', id, 'files'] as const,
  statuses: ['meeting-statuses'] as const,
  types: ['meeting-types'] as const,
  attendanceStatuses: ['meeting-attendance-statuses'] as const,
  venues: ['meeting-venues'] as const,
  settings: ['meeting-settings'] as const,
} as const;

/** Derived lifecycle state of a meeting (computed from dates + status). */
export type MeetingState = 'Upcoming' | 'In Progress' | 'Completed' | 'Cancelled';

export const MEETING_STATE_COLORS: Record<MeetingState, string> = {
  Upcoming: 'blue',
  'In Progress': 'orange',
  Completed: 'teal',
  Cancelled: 'red',
};

export const MEETING_STATE_OPTIONS: { value: MeetingState; label: string }[] = [
  { value: 'Upcoming', label: 'Upcoming' },
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Cancelled', label: 'Cancelled' },
];

/** Fallback colours by lookup id when a status/type row has no stored colour. */
export const DEFAULT_STATUS_COLORS: Record<number, string> = {
  1: 'blue',
  2: 'cyan',
  3: 'orange',
  4: 'teal',
  5: 'red',
  6: 'grape',
};

export const DEFAULT_TYPE_COLORS: Record<number, string> = {
  1: 'blue',
  2: 'grape',
  3: 'green',
  4: 'orange',
  5: 'red',
  6: 'cyan',
  7: 'pink',
  8: 'lime',
};
